import type { IconProps } from './IconProps';

export const SunIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <g clipPath="url(#clip0_1108_8323)">
      <path
        d="M7.99992 1.33331V2.66665M7.99992 13.3333V14.6666M2.66659 7.99998H1.33325M4.20933 4.20939L3.26652 3.26658M11.7905 4.20939L12.7333 3.26658M4.20933 11.7933L3.26652 12.7361M11.7905 11.7933L12.7333 12.7361M14.6666 7.99998H13.3333M11.3333 7.99998C11.3333 9.84093 9.84087 11.3333 7.99992 11.3333C6.15897 11.3333 4.66659 9.84093 4.66659 7.99998C4.66659 6.15903 6.15897 4.66665 7.99992 4.66665C9.84087 4.66665 11.3333 6.15903 11.3333 7.99998Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1108_8323">
        <rect width="16" height="16" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
